import { split, capitalize } from 'lodash'

export const formatOwnName = (name) => split(name, ' ').map(eachName => capitalize(eachName)).join(' ')

export const onlyNumber = (value) => value.split('').filter( (ele) => !isNaN(ele)).join('')
